import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import OtpInput from "react-otp-input"; // Import OTP Input component
import { useSendOTPMutation } from "../../Services/LoginAPI";
import "./style.css";

const OtpVerification = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email || ""; // Retrieve email from navigation state

    const [otp, setOtp] = useState("");
    const [errors, setErrors] = useState({ otp: "", apiError: "" });

    const [verifyOtp, { isLoading }] = useSendOTPMutation(); // RTK Query mutation

    // Validate OTP
    const handleSubmit = async (e) => {
        e.preventDefault();
        let newErrors = { otp: "", apiError: "" };

        if (otp.length !== 6) {
            newErrors.otp = "OTP must be exactly 6 digits.";
        }

        setErrors(newErrors);
        if (newErrors.otp) return;

        try {
            let formData = { email, otp };
            const response = await verifyOtp(formData).unwrap();
            console.log("response" , response)
            // Navigate to the password reset page after successful OTP verification
            const responseOtp = response.otp
            navigate("/reset-password", { state: { email , otp:responseOtp} });
        } catch (err) {
            console.error("OTP verification failed:", err?.data?.error);
            setErrors((prev) => ({
                ...prev,
                apiError: err.data?.error || err.data?.message || "Invalid OTP. Please try again.",
            }));
        }
    };

    const maskEmail = (email) => {
        if (!email) return "";
        const [name, domain] = email.split("@");
        if (name.length <= 2) {
            return `${name[0]}***@${domain}`; // Handle very short names
        }
        return `${name[0]}${"*".repeat(name.length - 2)}${name[name.length - 1]}@${domain}`;
    };
    

    return (
        <div className="login-container">
            <div className="login-box">
                <h2 className="text-center mb-4">Enter OTP</h2>
                <p className="text-center">
                    A 6-digit OTP has been sent to your email: <strong>{maskEmail(email)}</strong>
                </p>
                <form onSubmit={handleSubmit}>
                    {/* OTP Input */}
                    <div className="mb-3 text-center otp-input">
                        <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            isInputNum={true}
                            shouldAutoFocus={true}
                            containerStyle="otp-container"
                            inputStyle={{
                                width: "40px",
                                height: "40px",
                                margin: "5px",
                                fontSize: "20px",
                                textAlign: "center",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                            }}
                           
                            renderInput={(props) => <input {...props} />}
                        />
                        {errors.otp && <div className="text-danger mt-2">{errors.otp}</div>}
                    </div>

                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                        {isLoading ? "Verifying OTP..." : "Verify OTP"}
                    </button>
                    {errors.apiError && <div className="text-danger mt-2">{errors.apiError}</div>}
                </form>
            </div>
        </div>
    );
};

export default OtpVerification;
